import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import CookieConsentBanner from "./components/CookieConsentBanner";
import { AuthProvider } from "./store/AuthContext";
import { installResponsiveTables } from "./utils/responsiveTables";
import "./styles.css";
import "./fundraising-hero.css";
import "./investor-panel.css";
import "./wallet-page.css";
import "./marketing-site.css";
import "./marketing-rock-health-type.css";
import "./marketing-site-rh.css";
import "./marketing-join-portfolio.css";

class RootErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24, fontFamily: "system-ui,sans-serif", maxWidth: 720 }}>
          <h1 style={{ color: "#b91c1c" }}>The app hit an error</h1>
          <p>Copy this for support:</p>
          <pre
            style={{
              background: "#f3f4f6",
              padding: 12,
              overflow: "auto",
              fontSize: 13,
              borderRadius: 8,
            }}
          >
            {String(this.state.error?.message || this.state.error)}
            {"\n\n"}
            {this.state.error?.stack || ""}
          </pre>
          <p>
            <a href="/healthcheck.html">Static server check</a>
            {" · "}
            <a href="/">Retry home</a>
          </p>
        </div>
      );
    }
    return this.props.children;
  }
}

const el = document.getElementById("root");
if (!el) {
  document.body.innerHTML = "<p style='padding:24px;font-family:sans-serif'>Missing #root in index.html.</p>";
} else {
  const root = ReactDOM.createRoot(el);
  root.render(
    <BrowserRouter>
      <AuthProvider>
        <RootErrorBoundary>
          <App />
          <CookieConsentBanner />
        </RootErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
  installResponsiveTables(document.body);
}
